import '../../../common/js/3rdparty/date.js';
import '../../../common/js/3rdparty/prism.js';

import $ from 'webpack-zepto';
window.$ = $;

import Ajax from '../../../common/js/Ajax.js';
import Navigation from '../../../common/js/Navigation.js';
import NoIndex from '../../../common/js/NoIndex.js';
import WidgetLoader from '../../../common/js/WidgetLoader.js';

import DropDownWidget from '../../../common/js/dropdown/DropDownWidget.js';
import ZoomImage from '../../../common/js/image/ZoomImage.js';

import ExportWidget from "./export/ExportWidget.js";
import FinishPasswordResetWidget from "./auth/FinishPasswordResetWidget.js";
import LoginWidget from "./auth/LoginWidget.js";
import LogoutWidget from "./auth/LogoutWidget.js";
import RegisterWidget from "./auth/RegisterWidget.js";
import StartPasswordResetWidget from "./auth/StartPasswordResetWidget.js";
import TasksWidget from "./tasks/TasksWidget.js";

$(() => {
	Ajax.initialize();

	Navigation.initialize();
	NoIndex.initialize();
	ZoomImage.initialize();

	WidgetLoader.add('DropDownWidget', DropDownWidget);

	WidgetLoader.add("ExportWidget", ExportWidget);
	WidgetLoader.add("FinishPasswordResetWidget", FinishPasswordResetWidget);
	WidgetLoader.add("LoginWidget", LoginWidget);
	WidgetLoader.add("LogoutWidget", LogoutWidget);
	WidgetLoader.add("RegisterWidget", RegisterWidget);
	WidgetLoader.add("StartPasswordResetWidget", StartPasswordResetWidget);
	WidgetLoader.add("TasksWidget", TasksWidget);

	WidgetLoader.initialize();
});
